<template>
    <div v-if="componentData" class="wrapper FourCards">
        <h2 v-if="componentData.fourCardsTitle" class="four-cards__title">
            {{componentData.fourCardsTitle}}
        </h2>
        <div class="grid four">
            <div class="four-card__block" 
                 v-for="(block, index) in componentData.blocks" 
                 :key="index"
                 data-gsap="divPopin"
                 :data-gsap-delay="0.2 + index * 0.1">
                <figure class="four-card__image" v-if="block.image">
                    <img 
                        :src="block.image.data.attributes.url"
                        :alt="block.image.data.attributes.alternativeText || block.title || 'Card image'"
                        class="four-card-image"
                        loading="lazy"
                    />
                </figure>
                <div class="four-card__content">
                    <h3 v-if="block.title">{{block.title}}</h3>
                    <p v-if="block.description">{{block.description}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'

export default defineComponent({
    props:{
        componentData: {
            type: Object,
            required: false
        },
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL;

        return {
            homeurl
        };
    }
})

</script>
